import apiClient from '../../../services/apiClient';
import eventBus from '../../../services/globalEventBus';

type Event = {
  id: string;
  code: string;
};

export const acceptForPrefixAndGroupCode = (prefix: string, groupCode: string) => {
  return new Promise((resolve, reject) => {
    apiClient
      .post(`/v1/easy-link/${prefix}/${groupCode}`)
      .then(response => {
        const orgId = response.data;
        const unsubscribes: (() => void)[] = [];

        const unsubscribeAll = () => {
          unsubscribes.forEach(unsub => unsub());
        };

        unsubscribes.push(
          eventBus.subscribe('MembersAddedToOrgAccountGroup', (event: Event) => {
            if (event.id === orgId) {
              unsubscribeAll();
              resolve(event);
            }
          })
        );

        unsubscribes.push(
          eventBus.subscribe('OrgAccountError', (event: Event) => {
            if (event.id === orgId) {
              unsubscribeAll();
              reject(event);
            }
          })
        );

        unsubscribes.push(
          eventBus.subscribe('Already Exists Error', (event: Event) => {
            unsubscribeAll();
            reject(event.code);
          })
        );
      })
      .catch(err => {
        if (err.status === 404) {
          reject('NOT_FOUND');
        } else {
          reject(err);
        }
      });
  });
};
